(function(_){
    'use strict';
    _['FREE.KEY']='Página';
    _['FREE.NO-CONTENT'] = 'Este módulo no tiene contenido.';
}(translations['es']));












// WEBPACK FOOTER //
// ./src/app/modules/free/lang/free-lang_es.js